import { useTranslation } from 'react-i18next';
import { Meta } from '@/components/Meta';

export function PrivacyPage() {
  const { t } = useTranslation();
  return (
    <>
      <Meta title={t('meta.privacyTitle')} />
      <div className="u-container max-w-3xl pt-[22vh] pb-[16vh]">
        <h1 className="font-display text-5xl md:text-7xl">{t('privacy.title')}</h1>
        <p className="mt-10 leading-relaxed text-ink-soft">{t('privacy.body')}</p>
      </div>
    </>
  );
}
